import { Injectable } from '@angular/core';
import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable({
  providedIn: 'root'
})
export class GroupHasSecuredAppService extends RestfulService<Models.GroupHasSecuredApp> {

  constructor(private restService: RestService) {
    super(Models.GroupHasSecuredApp);

    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('group-has-secured-apps');
  }
}
